import {
  brandEntityId,
  BrandEntityId,
  brandLogoDataFile,
  BrandLogoDataFile,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoCreate1VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoCreate1VO.validationSchema()
  );

  constructor(readonly value: RoomBrandLogoCreate1) {
    JsonSchemaValidator.assert(RoomBrandLogoCreate1VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandLogoDataFile
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoCreate1 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandLogoDataFile;
}
